module.exports = __webpack_public_path__ + "media/images/faces/face5-6e5237c6572cb6822ec69ad181bdf409.jpg";